import { render, staticRenderFns } from "./SingleServiceSummary.vue?vue&type=template&id=0ec63c0c&"
import script from "./SingleServiceSummary.vue?vue&type=script&lang=js&"
export * from "./SingleServiceSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports